<template>
  <div class="profil-container" v-if="finish.length > 0">
    <h3 class="profil-title" v-if="formIsActive(finish[0])">
      {{ finish[0].text }}
    </h3>
    <p class="profil-subtitle" v-if="formIsActive(finish[1])">
      {{ finish[1].text }}
    </p>

    <div class="profil-btn-wrapper" v-if="!$store.state.landingpage.registerDone">
      <div @click="registerVendor()" class="btn-landing">
        Selesai
      </div>
      <div @click="goBack()" class="btn-landing">Kembali</div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    finish() {
      return this.$store.state.landingpage.md_step_7
    },
  },
  methods: {
    async registerVendor() {
      const { query } = this.$store.state.landingpage
      let pageName = this.$route.path
      console.log('pagename: ', pageName)
      let isReview = false

      if (
        (pageName && pageName.split('/')[1] == 'review-from-landing-page') ||
        (pageName && pageName.split('/')[1] == 'review-landing-page') ||
        (pageName && pageName.split('/')[1] == 'pra-legal')
      ) {
        isReview = true
      }

      if (query == 'bu') {
        await this.$store.commit('landingpage/COMBINE_LEGAL_DOC', {
          badan: 'bu',
          review: isReview,
        })
      } else {
        await this.$store.commit('landingpage/COMBINE_LEGAL_DOC', {
          badan: 'perorangan',
          review: isReview,
        })
      }

      if (isReview) {
        await this.$store.commit('landingpage/SEND_REGISTER_DATA', {
          process: 'review',
        })
      } else {
        await this.$store.commit('landingpage/SEND_REGISTER_DATA', {
          process: 'create',
        })
      }
    },
    goBack() {
      const { query } = this.$store.state.landingpage

      if (query == 'bu') {
        this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'legalitasbu')
      } else {
        this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'legalitas')
      }
    },
  },
}
</script>
